import { useMutation } from 'react-query';
import createQuote from 'api/quote/createQuote';

const useCreateQuote = () => useMutation(createQuote);

const useCreateGetQuote = ({ params }) => {
  const {
    isLoading: isCreatingQuote,
    isError: isCreatingQuoteError,
    isSuccess: isCreatingQuoteSuccess,
    mutate: mutateCreateQuote,
    data,
  } = useCreateQuote();

  const handleCreateQuote = () => {
    mutateCreateQuote({ params });
  };

  return {
    isLoading: isCreatingQuote,
    isError: isCreatingQuoteError,
    isSuccess: isCreatingQuoteSuccess,
    handleCreateQuote,
    data,
  };
};

export default useCreateGetQuote;
